import { render } from "./LoginDelivery.vue?vue&type=template&id=70ddb7c2&scoped=true"
import script from "./LoginDelivery.vue?vue&type=script&lang=js"
export * from "./LoginDelivery.vue?vue&type=script&lang=js"

import "./LoginDelivery.vue?vue&type=style&index=0&id=70ddb7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ddb7c2"]])

export default __exports__